import {
  SET_ACTIVE_SORTING_COLUMN,
  SET_SORTING_DIRECTION,
  SET_SELECTED_FILTERS,
  SET_LOCAL_SYNC_TOGGLE,
} from "./taskFiltersTypes";
import { TaskSortingDirection } from "./types";

export interface TaskFiltersReducerState {
  activeSortingColumn: string | null;
  sortingDirection: TaskSortingDirection;
  selectedFilters: any;
  localSyncToggle: boolean;
}

const initialState: TaskFiltersReducerState = {
  activeSortingColumn: null,
  sortingDirection: TaskSortingDirection.Descending,
  selectedFilters: {},
  localSyncToggle: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
function taskFiltersReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_ACTIVE_SORTING_COLUMN:
      return {
        ...state,
        activeSortingColumn: action.payload.activeSortingColumn,
      };
    case SET_SORTING_DIRECTION:
      return {
        ...state,
        sortingDirection: action.payload.sortingDirection,
      };
    case SET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: action.payload.selectedFilters,
      };
    case SET_LOCAL_SYNC_TOGGLE:
      return {
        ...state,
        localSyncToggle: action.payload.localSyncToggle,
      };
    default:
      return state;
  }
}

export default taskFiltersReducer;
